import React,{useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input,} from 'antd';
import { useBnsGongNengUpdateQuery, useBnsGongNengUpdateSaveMutation } from '../../store/BnsKeJiApi';
import { EditOutlined } from '@ant-design/icons';
const {TextArea} = Input
function ModuleEdit(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bgn_content:''
    }); 
    const {data,isSuccess} = useBnsGongNengUpdateQuery({bgn_id:props.bgn_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                         
                editForm.current.setFieldsValue({
                    bgn_name:data.Result.bgn_name,
                    bgn_dept_id:data.Result.bgn_dept_id,
                    bgn_content:data.Result.bgn_content,
                    bgn_luyou:data.Result.bgn_luyou,
                    bgn_state:data.Result.bgn_state,
                    bgn_goods:data.Result.bgn_goods,
                    bgn_price:data.Result.bgn_price,
                    bgn_bg_id:[data.Result.bgn_bg_id],
                })
                setInfo(prevState=>({...prevState,
                    bgn_name:data.Result.bgn_name,                  
                    bgn_dept_id:data.Result.bgn_dept_id,                  
                    bgn_content:data.Result.bgn_content,                  
                    bgn_dept_name:data.Result.bgn_dept_name,
                    bgn_image:data.Result.bgn_image,
                    bgn_luyou:data.Result.bgn_luyou,
                    bgn_state:data.Result.bgn_state,                  
                    bgn_goods:data.Result.bgn_goods,                  
                    bgn_bg_id:data.Result.bgn_bg_id,                  
                    bgn_price:data.Result.bgn_price,                  
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsGongNengUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/> 修改模块</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改模块'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bgn_e_id" : localStorage.getItem('e_id'),
                        "bgn_id" : props.bgn_id,
                        "bgn_bg_id" : info.bgn_bg_id,
                        "bgn_name" : info.bgn_name,
                        "bgn_content" : info.bgn_content,
                        "bgn_dept_id" : '7',
                        "bgn_dept_name" : '开发部',
                        "bgn_uid" :localStorage.getItem('eu_id'),
                        "bgn_uname" : localStorage.getItem('eu_name'),  
                        "bgn_image" : info.bgn_image,
                        "bgn_luyou" : info.bgn_luyou,
                        "bgn_state" : info.bgn_state,                               
                        "bgn_goods" : info.bgn_goods,                               
                        "bgn_price" : info.bgn_price,                               
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                    
                >                    
                    <Form.Item name="bgn_name" label='模块名称' wrapperCol={{span:10}} required>
                        <Input 
                            onChange={(e) => {
                                setInfo(prevState=>({...prevState,bgn_name:e.target.value}))}
                            }
                        />
                    </Form.Item> 
                    <Form.Item name="bgn_content" label='备注' wrapperCol={{span:20}}>
                        <TextArea 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bgn_content:e.target.value}))}}
                        />
                    </Form.Item> 
                   
                </Form>
            </Modal>
        </>
    )
}

export default ModuleEdit